import { DomainNamesTabGroupEnum } from '~/pages/DomainNames/@types';
import { MarketplaceListingTabGroupEnums } from '~/pages/Marketplace/Listings/@types';
import { SocialMediaListingTabGroupEnums } from '~/pages/SocialMedia/_impersonation/Listings/@types';
import { WebsiteContentTabGroupEnum } from '~/pages/WebsiteContent/_impersonation/@types';
import {
  DomainNamesRouteEnum,
  MarketplaceListingsRouteEnum,
  SocialMediaListingsRouteEnum,
  WebsiteContentRouteEnum,
} from '~/router/@types';

export type ChannelGroup = 'marketplace' | 'social media' | 'domain names' | 'website content';
export type RouteGroup =
  | MarketplaceListingsRouteEnum
  | SocialMediaListingsRouteEnum
  | DomainNamesRouteEnum
  | WebsiteContentRouteEnum;
export type TabGroup =
  | MarketplaceListingTabGroupEnums
  | SocialMediaListingTabGroupEnums
  | DomainNamesTabGroupEnum
  | WebsiteContentTabGroupEnum;

export type FilterGroup =
  | 'Platform and Seller Information'
  | 'Listing Attributes'
  | 'Price and Sales'
  | 'Infringing features'
  | 'Others'
  | 'Enforcement'
  | 'Date'
  | 'None'
  | 'Test Purchase case information';

export const enum FilterTypeEnum {
  PLATFORMS = 'Platforms',
  SELLER = 'Sellers',
  REPEAT_OFFENDER = 'Repeat offender',
  ASSET = 'Assets',
  MODELS = 'Models',
  SHIP_FROM = 'Ship from',
  CUSTOM_TAGS = 'Tags',
  LOW_PRICE = 'Low price',
  PRICE = 'Price',
  SALES_VOLUME = 'Sales volume',
  REPORT_REASON = 'Report reason',
  SMART_RULE = 'Smart rules',
  DATE = 'Updated date',
  LIKELY_COUNTERFEIT = 'Likely counterfeit',
  REPORTED_BY_USER = 'Requested by me',
  TOP_RESULTS = 'Top search results',
  COPYRIGHTED_IMAGE = 'Copyrighted image used',
  INFRINGING_IMAGE = 'Infringing image used',
  TRADEMARKED_LOGO = 'Trademarked logo used',
  TRADEMARKED_TEXT = 'Trademarked text used',
  POST_TYPE = 'Post/Profile',
  COMMENT_USER_TYPE = 'Comments',
  TEST_PURCHASE_PROGRESS = 'Test Purchase progress',
  TEST_PURCHASE_REPORT = 'Test Purchase report',
  // Domain Names & Website content 필터
  COUNTRY = 'Country',
  LOGO_DETECTED = 'Logo detected',
  SCANNED_DATE = 'Scanned date',
  GENERIC_CUSTOM_TAGS = 'Generic custom Tags',
  FAVICON_DETECTED = 'Favicon detected',
  ADDED_DATE = 'Added date',
  REQUESTED_DATE = 'Requested date',
  SSL_CERTIFICATE = 'SSL certificate',
  MX_RECORDS = 'MX records',
  // Domain Names 전용 필터
  AI_CLASSIFICATION = 'AI Classification',
  DOMAIN_NAMES_COMMENT_USER_TYPE = 'Domain Names Comments',
  // Website content 전용 필터
  DOMAIN = 'Domain',
  WEBSITE_CONTENT_COMMENT_USER_TYPE = 'Website Content Comments',
  WEBSITE_CONTENT_TEST_PURCHASE_PROGRESS = 'Website Content Test Purchase progress',
}

export type FilterItem = {
  type: FilterTypeEnum;
  enabled: boolean;
};

export type FilterGroups = Partial<Record<FilterGroup, FilterItem[]>>;
